var wrappers = require('./dist-modules/higher-order.js');
exports.root = wrappers.root;
exports.branch = wrappers.branch;
